<template>
  <Row style="padding: 20px">
    <Col span="18">
      <!-- <Input
        disabled
        v-model="searchParams.name"
        placeholder="商品名称"
        class="public_inp"
      /> -->
      <!-- <Input
        v-model="searchParams.skuCode"
        placeholder="SKU编码"
        class="public_inp"
        style="width: 40%"
      />
      <Input
        v-model="searchParams.platformCode"
        placeholder="平台编码"
        class="public_inp"
        style="width: 40%"
      /> -->
      <Select v-model="searchParams.skuCode" style="width: 40%" placeholder="SKU编码">
        <Option value="">全部</Option>
        <Option v-for="item in SKUList.data || []" :key="item.code" :value="item.code">{{item.name || ''}}</Option>
      </Select>
      <Select v-model="searchParams.platformCode" style="width: 40%" placeholder="平台编码">
        <Option value="">全部</Option>
        <Option v-for="item in baseSysPlatformAll" :key="item.code" :value="item.code">{{item.name || ''}}</Option>
      </Select>
      <Button type="primary" @click="getList">搜索</Button>
      <Button @click="resetList">重置</Button>
    </Col>
    <Col span="6">
      <Button type="primary" icon="md-add" class="public_fr" @click="addSKU"
        >添加SKU</Button
      >
      <Button type="info" icon="ios-redo" class="public_fr">日志</Button>
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="skuPlatformList.data"
      >
        <template slot-scope="{ index }" slot="no">
          <span>{{
            searchParams.pageSize * (searchParams.page - 1) + index + 1
          }}</span>
        </template>
        <template slot-scope="{ row }" slot="updatetime">
          <span>{{ new Date(row.updatetime).toLocaleString() }}</span>
        </template>
        <template slot-scope="{ row }" slot="createtime">
          <span>{{ new Date(row.createtime).toLocaleString() }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <!-- <a href="javascript:;" @click="editSKU(row, index)">编辑</a> -->
          <a href="javascript:;" @click="removeFn(index, row)">删除</a>
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="skuPlatformList.total"
        show-sizer
        show-total
        prev-text="Previous"
        next-text="Next"
        show-elevator
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formStatus == 'add' ? '添加' : '编辑'"
      :mask-closable="false"
      width="50%"
      :loading="addModalLoading"
      @on-cancel="cancel"
      @on-ok="addAction"
    >
      <Form v-if="formModel" ref="formValidate" :model="formItem" :rules="addModalFormValidate" :label-width="80">
        <FormItem label="平台编码" prop="platformCode">
          <Transfer
            :data="baseSysPlatformAllTrasnfer"
            :target-keys="formItem.platformCode"
            filterable
            @on-change="transferChange"
          ></Transfer>
        </FormItem>
        <FormItem label="sku编码" prop="skuCode">
          <Input
            :value="formItem.skuCode.join(',')"
            disabled
            placeholder="请选择SKU"
          >
            <div slot="append">
              <Button
                type="primary"
                icon="ios-create"
                @click="selectSKUModalVisble = true"
                >选择SKU</Button
              >
            </div>
          </Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formItem.remark" placeholder="请输入名称"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="selectSKUModalVisble"
      :footer-hide="true"
      title="选择SKU"
      width="70%"
    >
      <skuList
        v-if="formModel"
        :select="tableSku"
        @onSelect="selectSku"
        @onCancel="selectSKUModalVisble = false"
      />
    </Modal>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
import skuList from "../../components/sku/list.vue";
const columns = [
  {
    title: "序号",
    slot: "no",
  },
  {
    title: "平台名称",
    key: "platformName",
  },
  {
    title: "ERP Code",
    key: "erpCode",
  },
  {
    title: "备注",
    key: "remark",
  },
  {
    title: "更新时间",
    slot: "updatetime",
  },
  {
    title: "创建时间",
    slot: "createtime",
  },
  {
    title: "操作",
    slot: "action",
    width: 100,
  },
];
const defaultSearchParams = {
  name: "",
  status: 0,
  skuCode: "",
  platformCode: "",
  page: 1,
  pageSize: 10,
};
const defaultModalForm = {
  platformCode: [],
  skuCode: [],
  remark: "",
};

const validateSkuCode = (rule, value, callback) => {
    if (value && value.length) {
        callback();
    } else{
        callback(new Error('请选择sku编码'));
    }
};
export default {
  data() {
    return {
      loading: false,
      addModalLoading: true,
      columns,
      formModel: false,
      formStatus: "add",
      addModalFormValidate: {
        platformCode: [{ required: true, type: 'array', message: '请选择平台编码', trigger: 'change' }],
        skuCode: [{ required: true, validator: validateSkuCode, trigger: 'change' }]
      },

      formItem: JSON.parse(JSON.stringify(defaultModalForm)),
      searchParams: JSON.parse(JSON.stringify(defaultSearchParams)),

      transferTargetKeys: [],
      skuCodeList: [],
      selectSKUModalVisble: false,
      tableSku: {},
    };
  },
  computed: {
    ...mapGetters("stageInfo", {
      skuPlatformList: "getSKUPlatformList",
      SKUList: "getSKUList",
    }),
    ...mapGetters("base", {
      baseSysPlatformAll: "getBaseSysPlatformAll",
    }),
    baseSysPlatformAllTrasnfer: function () {
      this.baseSysPlatformAll.map((item) => {
        item["key"] = item.code;
        item["label"] = item.name;
      });

      return this.baseSysPlatformAll;
    },
  },
  watch: {
    formModel: function (newv, oldv) {
      if (!newv) {
        this.addModalLoading = true;
        this.transferTargetKeys = [];
        this.skuCodeList = [];
        this.formItem = JSON.parse(JSON.stringify(defaultModalForm));
      }
    },
  },
  components: { skuList },
  created() {
    this.getList();
    // 查询所有SKU
    this.$store.dispatch("stageInfo/getSKUList", {
      pageSize: 100
    })
    // 查询系统平台基础及控制信息
    this.$store.dispatch("base/getBaseSysPlatformAll");
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("stageInfo/getSKUPlatformList", this.searchParams)
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageChange(page) {
      this.searchParams.page = page;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize;
      // 页码变动触发pageChange
      if (this.searchParams.page == 1) {
        this.getList();
      } else {
        this.searchParams.page = 1;
      }
    },
    // 重置
    resetList() {
      this.searchParams = JSON.parse(JSON.stringify(defaultSearchParams));
      this.getList();
    },
    // 日志
    detailFn(d, i) {},
    addSKU() {
      this.formStatus = "add";
      this.openFn();
    },
    editSKU(d, i) {
      this.formStatus = "edit";
      this.formItem.platformCode = d.platformCode;
      this.formItem.skuCode = d.skuCode;
      // 处理穿梭框
      this.transferTargetKeys = this.formItem.platformCode.split(",");
      // 处理sku编码
      this.skuCodeList = this.formItem.skuCode.split(",");

      this.formItem.skuCode = d.skuCode;
      this.formItem.remark = d.remark;

      this.openFn();
    },
    // 打开新增编辑
    openFn(d, i) {
      this.formModel = true;
    },
    cancel() {
      this.formModel = false;
      this.$set(this, "tableSku", {})
      this.formItem.skuCode = [];
    },
    transferChange(newTargetKeys) {
      this.formItem.platformCode = newTargetKeys;
    },
    // 新增编辑
    addAction() {
      const textSuffix = this.formStatus == "add" ? "添加" : "更新";
      // 处理transferTargetKeys
      //   this.formItem.platformCode = this.transferTargetKeys.join(",");
      // 处理skuCodeList
      //   this.formItem.skuCode = this.skuCodeList.join(",");
      this.$refs["formValidate"].validate(valid => {
        if(valid){
          this.$store
            .dispatch(
              this.formStatus == "add"
                ? "stageInfo/addSKUPlatform"
                : "stageInfo/updateSKUPlatform",
              this.formItem
            )
            .then((res) => {
              if (res.code == "200") {
                this.$Message.success(`${textSuffix}成功`);
                // 更新列表
                this.getList();
                this.formModel = false;
              } else {
                this.$Message.error(res.message || `${textSuffix}失败`);
              }

              this.formModel = false;
            })
            .catch((err) => {
              console.error(err);
              this.$Message.error(`${textSuffix}失败`);
            });
        }else{
          this.addModalLoading = false;
          this.$nextTick(() => {
            this.addModalLoading = true;
          })
        }
      })
      
    },
    // 删除部门
    removeFn(i, d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.$store
            .dispatch("stageInfo/deleteSKUPlatform", {
              platformCode: d.platformCode,
              skuCode: d.skuCode,
            })
            .then((res) => {
              if (res.code == "200") {
                this.$Message.success("删除成功");
                // 更新列表
                this.getList();
              } else {
                this.$Message.error(res.message || "删除失败");
              }
            })
            .catch((err) => {
              console.error(err);
              this.$Message.error("删除失败");
            });
        },
      });
    },
    selectSku(sku) {
      this.$set(this, "tableSku", sku)
      let skuList = [];
      Object.keys(sku).forEach((key) => {
        sku[key].forEach((sku) => {
          skuList.push(sku.code);
        });
      });
      
      this.formItem.skuCode = skuList;
      this.selectSKUModalVisble = false;
    },
  },
};
</script>
<style scoped>
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
.tip {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/commodity/stageInfo.vue